<template>
  <div>
    <page-title
      :title="$t('components.founders.title')"
      title-tag="h2"
      :back-button="{ url: breadcrumbs[0].link, hiddenAfterSizes: 'sm' }"
      :bordered="true"
    />
    <div class="px-20 px-sm-30 my-20 my-md-30 my-lg-40">
      <breadcrumb :breadcrumbs="breadcrumbs" />
      <founder-detail :info="info" />
      <learn-more-about-airalo
        link="/about-us/about-airalo"
        :title="$t('components.learn.more.about.airalo.founders-title')"
      />
    </div>
  </div>
</template>

<script>
  import Breadcrumb from '~/components/partner-with-us/breadcrumb'
  import FounderDetail from '~/components/about-us/founder-detail'
  import LearnMoreAboutAiralo from '~/components/about-us/learn-more-about-airalo'
  import founderMixin from '~/mixins/founder'

  export default {
    name: 'ahmet-bahadir-ozdemir',

    components: {
      LearnMoreAboutAiralo,
      FounderDetail,
      Breadcrumb,
      PageTitle: () => import('~/components/shared/page-title.vue'),
    },

    mixins: [
      founderMixin(
        'components.founders.founder.ahmet-bahadir-ozdemir.name',
        'components.founders.founder.ahmet-bahadir-ozdemir.title',
        'components.founders.founder.ahmet-bahadir-ozdemir.motto',
        '/assets/images/about-us/about-airalo-founders-bahadir.png',
        'ahmet-bahadir-ozdemir-desc'
      ),
    ],
    head() {
      return {
        title: this.$te('seo.about.us.founders.ahmet-bahadir-ozdemir-title')
          ? this.$t('seo.about.us.founders.ahmet-bahadir-ozdemir-title')
          : this.$t('seo.homepage.title'),
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: this.$t('seo.about.us.founders.ahmet-bahadir-ozdemir-description'),
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content: this.$t('seo.about.us.founders.ahmet-bahadir-ozdemir-keywords'),
          },
          {
            property: 'og:title',
            content: this.$t('seo.about.us.founders.ahmet-bahadir-ozdemir-title'),
          },
          {
            property: 'og:description',
            content: this.$t('seo.about.us.founders.ahmet-bahadir-ozdemir-description'),
          },
        ],
      }
    },
  }
</script>
